const atlantidaMallorcaTalentsLab = [
  {
    id: "atlantidaMallorcaTalentsLab",
    isInline: true,
    title: {
      es: "Atlàntida Mallorca Talents Lab",
      cat: "Atlàntida Mallorca Talents Lab",
    },
    items: [
      {
        title: "Europa Creativa",
        image: "amtl-europa-creativa.png",
        size: 1.3,
        original: true,
        link: {
          cat: "",
          es: "",
        },
      },
      {
        title: "Europa Creativa Oficina España",
        image: "oficina-españa.png",
        size: 1.3,
        original: true,
        link: {
          cat: "",
          es: "",
        },
      },
      // {
      //   link: {
      //     es: "https://www.oficinamediaespana.eu/",
      //     cat: "https://www.oficinamediaespana.eu/",
      //   },
      //   title: "Oficina MEDIA España",
      //   image: "amtl-oficina-media.jpg",
      //   size: 1.4,
      //   original: true,
      // },
      {
        link: {
          es: "https://elasticafilms.com",
          cat: "https://elasticafilms.com",
        },
        title: "Elastica Films",
        image: "amtl-elastical-films.png",
        size: 0.4,
        original: true,
      },
      {
        link: {
          es: "https://www.deluxe-spain.com/es",
          cat: "https://www.deluxe-spain.com/es",
        },
        title: "DELUXE",
        image: "amtl-deluxe.png",
        size: 1,
        original: true,
      },
    ],
  },
];

export default atlantidaMallorcaTalentsLab;
